import { useMutation, useQuery } from "react-query";
import { Get, Post } from "../apis/api";

export const useVisaList = () => useQuery({
    queryFn: () => Get('agent/visas'),
    queryKey: ['Get-Visas']
})


export const useNotifications = (page = 1, per_page = 10, enable = false) => useQuery({
    queryFn: ({ queryKey }) => Get(`notification/unread?page=${queryKey[1]}&per_page=${queryKey[2] || 10}`),
    queryKey: ['Get-Notifs', page, per_page, enable],
    refetchInterval: 1000 * 60 * 5,
    enabled: enable
})

export const useReadNotif = () => useMutation({
    mutationFn: ({ id }) => Post(`notification/read/${id}`),
    mutationKey: ['Send-Notifs']
})

export const useWallet = () => useQuery({
    queryFn: () => Get('agent/transactions/wallets/deposit'),
    queryKey: ['Wallet-Ballance']
})